export * from './prism-logo.component';



// WEBPACK FOOTER //
// ./src/app/shared/components/prism-logo/index.ts